import styled, {createGlobalStyle} from "styled-components";
import {Layout, PageHeader, Menu} from "antd";

const mapPaths = ["/map", "/heatmap", "/create-delivery-request", "/anlik-operasyon"];
const isLogin = pathname => pathname === "/login";
const isMap = pathname => {
    if (mapPaths.includes(pathname)) {
        return true;
    }
    if (/^\/orders\/[a-f0-9]+$/i.test(pathname)) {
        return "orders";
    }
    return false;
};
export const LayoutSider = styled(Layout.Sider)`
    overflow: auto;
    height: 100vh;
    position: fixed;
    transition: all 0.2s ease-in-out;
    .ant-layout-sider-trigger {
        background: #616161 !important;
    }
    .ant-menu.ant-menu-dark .ant-menu-item-selected {
        background-color: transparent !important;
    }
    .ant-menu.ant-menu-dark {
        background: black !important;
    }
    /* Disabled (başlık) öğeler beyaz renkte olacak */
    .ant-menu.ant-menu-dark .ant-menu-item-disabled,
    .ant-menu.ant-menu-dark .ant-menu-item-disabled > span,
    .ant-menu.ant-menu-dark .ant-menu-item-disabled span,
    .ant-menu.ant-menu-dark .ant-menu-item-disabled .anticon {
        color: #ffffff !important;
        cursor: default !important;
    }

    /* ========== AKTİF MENÜ STİLLERİ ========== */

    /* 1. Alt menüsü olmayan seçili sayfa - yazı ve ikon #aef001 */
    .ant-menu.ant-menu-dark .ant-menu-item-selected > a,
    .ant-menu.ant-menu-dark .ant-menu-item-selected > a > span,
    .ant-menu.ant-menu-dark .ant-menu-item-selected > a > .anticon,
    .ant-menu.ant-menu-dark .ant-menu-item-selected > span > a,
    .ant-menu.ant-menu-dark .ant-menu-item-selected > span > a > span,
    .ant-menu.ant-menu-dark .ant-menu-item-selected > span > a > .anticon {
        color: #aef001 !important;
        font-weight: bold !important;
    }

    /* 2. Alt menü açıkken - seçili alt menü öğesinin yazı ve ikonu #aef001 */
    .ant-menu.ant-menu-dark .ant-menu-submenu-open .ant-menu-item-selected > a,
    .ant-menu.ant-menu-dark .ant-menu-submenu-open .ant-menu-item-selected > a > span,
    .ant-menu.ant-menu-dark .ant-menu-submenu-open .ant-menu-item-selected > a > .anticon,
    .ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-item-selected > a,
    .ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-item-selected > a > span,
    .ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-item-selected > a > .anticon {
        color: #aef001 !important;
        font-weight: bold !important;
    }

    /* 3. Alt menü kapalıyken - üst menü başlığı #aef001 (collapsed olmayan durumda, submenu kapalıyken) */
    .ant-menu.ant-menu-dark
        .ant-menu-submenu-selected:not(.ant-menu-submenu-open)
        > .ant-menu-submenu-title,
    .ant-menu.ant-menu-dark
        .ant-menu-submenu-selected:not(.ant-menu-submenu-open)
        > .ant-menu-submenu-title
        > span,
    .ant-menu.ant-menu-dark
        .ant-menu-submenu-selected:not(.ant-menu-submenu-open)
        > .ant-menu-submenu-title
        > .anticon {
        color: #aef001 !important;
        font-weight: bold !important;
    }

    /* 3.5. Alt menü açıkken - üst menü başlığı beyaz ve bold */
    .ant-menu.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title,
    .ant-menu.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > span,
    .ant-menu.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .anticon {
        color: #ffffff !important;
        font-weight: bold !important;
    }

    /* 4. Sidebar collapsed (daraltılmış) iken - seçili alt menüsü olan üst menü ikonu #aef001 */
    &.ant-layout-sider-collapsed
        .ant-menu.ant-menu-dark
        .ant-menu-submenu-selected
        > .ant-menu-submenu-title,
    &.ant-layout-sider-collapsed
        .ant-menu.ant-menu-dark
        .ant-menu-submenu-selected
        > .ant-menu-submenu-title
        > .anticon {
        color: #aef001 !important;
        font-weight: bold !important;
    }

    /* SubMenu ve alt öğelerin hizalaması - padding ayarları */
    .ant-menu-inline .ant-menu-submenu-title {
        padding-left: 24px !important;
    }
    .ant-menu-inline .ant-menu-item {
        padding-left: 24px !important;
    }
    .ant-menu-inline.ant-menu-sub .ant-menu-item {
        padding-left: 24px !important;
    }
    /* Alt menü arka plan rengi - popup ile aynı */
    .ant-menu-inline.ant-menu-sub {
        background: #001122 !important;
    }
    /* Inline menüde small font öğeleri için stil */
    .ant-menu-inline .ant-menu-item.small-font-item {
        height: 32px !important;
        line-height: 32px !important;
        margin-top: 8px !important;
        margin-left: 24px !important;
    }
    .ant-layout-sider-children {
        overflow-y: auto;
        overflow-x: hidden;
    }
    @media screen and (max-width: 768px) {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100vw !important;
        max-width: 100vw !important;
        min-width: 100vw !important;
        transform: ${props => (props.collapsed ? "translateX(-100%)" : "translateX(0)")};
        &.ant-layout-sider-collapsed {
            width: 0 !important;
            min-width: 0 !important;
            max-width: 0 !important;
            transform: translateX(-100%);
        }
        .ant-layout-sider-trigger {
            width: 100% !important;
        }
    }
`;

export const MenuPopupGlobalStyle = createGlobalStyle`
    /* Sadece popup container'a border-radius uygula, ikonlara değil */
    .ant-menu-submenu-popup {
        border-radius: 10px !important;
    }
    .ant-menu-submenu-popup > .ant-menu {
        border-radius: 10px !important;
    }
    /* Popup menü öğelerinin yüksekliğini artır */
    .ant-menu-submenu-popup .ant-menu-item {
        height: 44px !important;
        line-height: 44px !important;
    }
    /* Popup menüde disabled öğeler beyaz olacak */
    .ant-menu-submenu-popup .ant-menu-item-disabled,
    .ant-menu-submenu-popup .ant-menu-item-disabled > span,
    .ant-menu-submenu-popup .ant-menu-item-disabled span,
    .ant-menu-submenu-popup .ant-menu-item-disabled .anticon {
        color: #ffffff !important;
        cursor: default !important;
    }
    /* Small font öğeleri için stil */
    .ant-menu-submenu-popup .ant-menu-item.small-font-item {
        height: 32px !important;
        line-height: 32px !important;
        margin-top: 8px !important;
    }
    
    /* ========== POPUP MENÜDE AKTİF ÖĞELER ========== */
    /* Popup menüde seçili alt menü öğesi - arka plan şeffaf */
    .ant-menu-submenu-popup .ant-menu-item-selected {
        background-color: transparent !important;
    }
    /* Popup menüde seçili alt menü öğesi - yazı ve ikon #aef001 */
    .ant-menu-submenu-popup .ant-menu-item-selected > a,
    .ant-menu-submenu-popup .ant-menu-item-selected > a > span,
    .ant-menu-submenu-popup .ant-menu-item-selected > a > .anticon,
    .ant-menu-submenu-popup .ant-menu-item-selected > span > a,
    .ant-menu-submenu-popup .ant-menu-item-selected > span > a > span,
    .ant-menu-submenu-popup .ant-menu-item-selected > span > a > .anticon {
        color: #aef001 !important;
        font-weight: bold !important;
    }
`;

export const RightLayout = styled(Layout)`
    transition: all 0.2s ease 0s;
    margin-left: ${props => (props.isloggedin ? (props.collapsed ? 80 : 260) : 0)}px;
    @media screen and (max-width: 768px) {
        margin-left: 0 !important;
    }
`;

export const LayoutContainer = styled(Layout)`
    min-height: 100vh;
    .ant-layout-sider {
        background: black;
    }
`;

export const LayoutHeader = styled(PageHeader)`
    background: #fff;
    z-index: 2;
    box-shadow: rgba(75, 74, 73, 0.2) 0px 1px 4px 1px;

    @media screen and (max-width: 768px) {
        .ant-page-header-heading {
            margin-left: 28px;
        }
    }
`;

export const LayoutContent = styled(Layout.Content)`
    margin: ${props => (isMap(props.pathname) ? 0 : 16)}px;
    overflow: hidden;
    @media (max-width: 768px) {
        margin: 0px;
    }
`;

export const ChildrenContainer = styled.div`
    padding: ${props =>
        isMap(props.pathname) === "orders" ? 12 : isMap(props.pathname) ? 0 : 24}px;
    background: ${props =>
        props.pathname === "/anlik-operasyon"
            ? "#f5f6f1"
            : props.pathname == "/statistics" ||
              /\/pools\/[^/]+\/payment-contracts$/.test(props.pathname) ||
              /\/sub-company\/payment-contract\/[^/]+$/.test(props.pathname)
            ? "transparent"
            : "#fff"};
    min-height: max(
        calc(
            100vh -
                ${props =>
                    (props.pathname === "/map" || props.pathname === "/create-delivery-request") &&
                    isMap(props.pathname)
                        ? 120
                        : 144}px
        ),
        500px
    );
    position: relative;
`;

export const LayoutFooter = styled(Layout.Footer)`
    text-align: center;
    padding: 0 6px 16px 0;
    color: #a6aaaf;
    user-select: none;
`;

export const LogoImg = styled.img`
    height: 80px;
    margin: auto;
    display: flex;
`;

export const CompanyImg = styled.img`
    height: 32px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    margin-top: -3px;
    cursor: pointer;
`;

export const MenuText = styled.span`
    margin-left: 4px;
`;

export const BottomMenu = styled(Menu)`
    position: sticky;
    bottom: -12px;
`;

export const LogoContainer = styled.div`
    cursor: pointer;
    @media screen and (min-width: 768px) {
        svg {
            display: none;
        }
    }
    @media screen and (max-width: 768px) {
        margin-left: 0px;
        padding: 10px;
        margin: "auto";
        margin-top: "15px";

        img {
            display: none;
        }
    }
`;

export const MobileMenuToggle = styled.div`
    display: none;
    position: fixed;
    top: 16px;
    left: 10px;
    z-index: 1000;
    background-color: ${props => (props.collapsed ? "#FFFFFF" : "transparent")};
    color: white;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

    @media screen and (max-width: 768px) {
        display: flex;
    }
`;
